import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação do Router
import { Link, Redirect} from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class TeamTrainingsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      dados: [],
    };

    //bind geral
    // handleChange e handleChangeSelect necessitam do bind nas tags
    this.botaoResultados = this.botaoResultados.bind(this);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.turmas)) {
      this.setState({dados: newProps.turmas});
    }
  }

  botaoResultados (cell, row) {
    var url = '/turma/editar/' + cell;

    var botao = (
      <Link className={'btn btn-primary btn-sm'} to={url}>
        <i className="fa fa-fw fa-pencil"></i>
      </Link>
    );

    return botao;
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há treinamentos pendentes'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="turma" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Turma</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoResultados} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default TeamTrainingsTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TeamTrainingsTab.js